/**
 * Lenses: the platform arranged by use case or by role.
 *
 * The definitions are not here. They are manifests served by the Agent Atlas
 * service (GET /agent-atlas/api/v1/lenses), resolved against the nav catalog
 * (config/nav/catalog.js) and the user's access by config/lenses/derive.js.
 * This file keeps only how a lens looks.
 */

/** CSS custom properties for a lens's accent: the colour, a rim and a tint (8-digit hex). */
export const lensStyle = (lens) => {
  const color = lens?.color || '#8B95A3';
  return { '--lens-color': color, '--lens-rim': `${color}8C`, '--lens-tint': `${color}1F` };
};

/** The name a lens is shown by: the manifest's label, or "Everything". */
export const lensName = (lens, t) => (lens && lens.id !== 'all' && lens.label
  ? lens.label
  : t('nav:lens.names.all'));
